import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const RedoIcon = (props) => {
  return (
 /*   <svg
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="13"
      viewBox="0 0 36 25"
      width="20">
      <path class="st0" d="M20.3,8.1V6c0-0.8,0.9-1.3,1.5-0.8l6.8,6c0.5,0.4,0.5,1.2,0,1.6l-6.8,6c-0.6,0.5-1.5,0-1.5-0.8v-2h-0.9  C12.4,16,5.9,20.3,3,27C3,16.8,10.7,8.6,20.3,8.1z"/>
     </svg>
*/
<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
width="9.000000pt" height="9.000000pt" viewBox="0 0 512.000000 512.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M4670 3235 c-245 -245 -447 -445 -451 -445 -3 0 -46 32 -95 72 -381
306 -841 497 -1344 558 -139 17 -452 14 -600 -5 -618 -79 -1156 -349 -1579
-791 -194 -203 -339 -410 -461 -659 -67 -137 -142 -327 -132 -336 8 -7 564
-189 579 -189 4 0 19 30 32 68 34 97 131 289 196 389 228 349 550 614 934 768
661 265 1413 156 1970 -285 l53 -42 -453 -454 -454 -454 1128 0 1127 0 0 1125
c0 619 -1 1125 -3 1125 -1 0 -202 -200 -447 -445z"/>
</g>
</svg>
  );
};

export default RedoIcon;
